// extracted by mini-css-extract-plugin
export var attributionImage = "RichTextConverter-module--attribution-image--0594c";
export var embeddedAsset = "RichTextConverter-module--embedded-asset--c55fc";
export var figure = "RichTextConverter-module--figure--86fb3";
export var fullWidth = "RichTextConverter-module--full-width--aa3d0";
export var left = "RichTextConverter-module--left--8ae9f";
export var playerWrapper = "RichTextConverter-module--player-wrapper--c32fe";
export var quote = "RichTextConverter-module--quote--2e59f";
export var reactPlayer = "RichTextConverter-module--react-player--5d422";
export var right = "RichTextConverter-module--right--ab2dc";